export const first_month = [1, .92, .83, .75, .67, .58, .5, .42, .33, .25, .17, .08];
export const last_month = [.08, .17, .25, .33, .42, .5, .58, .67, .75, .83, .92, 1];
export const  _MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
